"use strict";
var CustomElement_1 = require("./CustomElement");
var registerElement = function () { return window.customElements.define('wikipathways-pvjs', CustomElement_1.CustomElement); };
if (typeof (window) !== 'undefined' && typeof (document) !== 'undefined') {
    if (document.readyState === 'complete') {
        registerElement();
    }
    else {
        window.addEventListener('load', function listener(event) {
            window.removeEventListener('load', listener, false);
            registerElement();
        }, false);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvV2ViQ29tcG9uZW50L2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxpREFBK0M7QUFHL0MsSUFBTSxlQUFlLEdBQUcsY0FBTSxPQUFBLE1BQU0sQ0FBQyxjQUFjLENBQUMsTUFBTSxDQUFDLG1CQUFtQixFQUFFLDZCQUFhLENBQUMsRUFBaEUsQ0FBZ0UsQ0FBQztBQUUvRixFQUFFLENBQUEsQ0FBQyxPQUFNLENBQUMsTUFBTSxDQUFDLEtBQUssV0FBVyxJQUFJLE9BQU0sQ0FBQyxRQUFRLENBQUMsS0FBSyxXQUFXLENBQUMsQ0FBQyxDQUFDO0lBQ3BFLEVBQUUsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxVQUFVLEtBQUssVUFBVSxDQUFDLENBQUMsQ0FBQztRQUNyQyxlQUFlLEVBQUUsQ0FBQztJQUN0QixDQUFDO0lBQUMsSUFBSSxDQUFDLENBQUM7UUFDSixNQUFNLENBQUMsZ0JBQWdCLENBQUMsTUFBTSxFQUFFLGtCQUFrQixLQUFLO1lBQ25ELE1BQU0sQ0FBQyxtQkFBbUIsQ0FBQyxNQUFNLEVBQUUsUUFBUSxFQUFFLEtBQUssQ0FBQyxDQUFDO1lBQ3BELGVBQWUsRUFBRSxDQUFDO1FBQ3RCLENBQUMsRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNkLENBQUM7QUFDTCxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/WebComponent/index.js
// module id = 478
// module chunks = 0